import type { UUID } from '@/shared/types/userStandard';

/**
 * Shared id stamped onto every drag/drop payload for this surface so the tree's monitor and drop
 * targets ignore drags from anything else (dnd-kit emits no Pragmatic events, but any future
 * Pragmatic surface would). The type guards below are the practical filter; this is belt-and-braces.
 */
export const libraryDndContextId = Symbol('library-dnd');

// Pragmatic drag/drop data must be assignable to `Record<string | symbol, unknown>`, so these carry
// an index signature; `attachInstruction` later merges the hitbox instruction onto the same object.
export type TreeItemData = {
  [key: string | symbol]: unknown;
  type: 'library-tree-item';
  contextId: symbol;
  nodeId: UUID;
};

export function getTreeItemData(nodeId: UUID): TreeItemData {
  return { type: 'library-tree-item', contextId: libraryDndContextId, nodeId };
}

export function isTreeItemData(data: Record<string | symbol, unknown>): data is TreeItemData {
  return data.type === 'library-tree-item' && data.contextId === libraryDndContextId;
}

export type CollectionDropData = {
  [key: string | symbol]: unknown;
  type: 'library-collection-drop';
  contextId: symbol;
  collectionId: UUID;
};

export function getCollectionDropData(collectionId: UUID): CollectionDropData {
  return { type: 'library-collection-drop', contextId: libraryDndContextId, collectionId };
}

export function isCollectionDropData(
  data: Record<string | symbol, unknown>
): data is CollectionDropData {
  return data.type === 'library-collection-drop' && data.contextId === libraryDndContextId;
}
